(function () {
    'use strict';
    angular.module('wamasysApp').controller('EquipmentMetersController', EquipmentMetersController);
    EquipmentMetersController.$inject = ['$state', '$stateParams', 'EquipmentParc', '$translate'];
    function EquipmentMetersController($state, params, api, $translate) {
        var vm = this, generation = 0;
        vm.pageTitle = 'wamasysApp.equipmentParc.evolution.meters'; vm.kind = params.kind || 'INDIVIDUAL'; vm.page = 0;
        vm.tr = function (key) { return $translate.instant('wamasysApp.equipmentParc.evolution.' + key); };
        function fail(error) { vm.error = error.data && error.data.message || vm.tr('failed'); }
        function day(date) { return date ? date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) : null; }
        vm.load = function () {
            var current = ++generation; vm.error = null; vm.detail = null; vm.loading = true; vm.pagination = vm.page + 1;
            return api.get('meters', {kind: vm.kind, state: vm.state, search: vm.search, page: vm.page}).then(function (data) { if (current === generation) { vm.items = data.items; vm.total = data.total; } }).catch(fail).finally(function () { if (current === generation) { vm.loading = false; } });
        };
        vm.select = function (meter) {
            var current = ++generation; vm.meter = meter; vm.error = null;
            return api.get('meters/' + meter.kind + '/' + meter.id).then(function (data) {
                if (current !== generation) { return; } vm.meter = data.meter; vm.detail = data; vm.form = angular.copy(data.profile || {});
                ['acquisitionDate', 'warrantyEndDate', 'depreciationStartDate'].forEach(function (key) { if (vm.form[key]) { vm.form[key] = new Date(vm.form[key] + 'T12:00:00'); } });
                $state.go('equipment-meters', {kind: meter.kind, meterId: meter.id}, {notify: false, location: 'replace'});
            }).catch(fail);
        };
        vm.reload = function () { return vm.select(vm.meter); };
        vm.back = function () { $state.go('equipment-meters', {kind: vm.kind, meterId: null}, {notify: false, location: 'replace'}); return vm.load(); };
        vm.locations = function () { return (vm.meta.locations || []).filter(function (location) { return location.areaId === vm.meter.areaId && location.active; }); };
        vm.save = function () {
            vm.busy = true; vm.error = null; var data = angular.copy(vm.form);
            ['acquisitionDate', 'warrantyEndDate', 'depreciationStartDate'].forEach(function (key) { data[key] = day(data[key]); });
            return api.put('meters/' + vm.meter.kind + '/' + vm.meter.id, data).then(vm.reload).catch(fail).finally(function () { vm.busy = false; });
        };
        vm.meta = {};
        api.get('metadata').then(function (meta) { vm.meta = meta; vm.canEdit = meta.canEdit; return vm.load(); }).then(function () {
            if (params.meterId) {
                // La fiche reste accessible directement, même hors de la page courante.
                var found = (vm.items || []).filter(function (meter) { return meter.id === Number(params.meterId); })[0];
                return vm.select(found || {id: Number(params.meterId), kind: vm.kind});
            }
        }).catch(fail);
    }
})();
